import {
  readPrimaryEnvironmentTarget,
  resolveHttpRequestBaseUrl,
  type PrimaryEnvironmentTarget,
} from "./target";

/**
 * Build a fetch init that includes the desktop cloud bearer token when
 * available. Bearer-authenticated cloud runtimes must not send browser
 * credentials: those requests are commonly cross-origin and authenticate with
 * the runtime ticket, not cookies. In browser/cookie mode (no bearer), the base
 * init is returned unchanged — no extra `headers` key is injected — so existing
 * cookie-only call sites are byte-identical to their pre-fix shape.
 */
export function buildPrimaryFetchInit(base: RequestInit = {}): RequestInit {
  const target = readPrimaryEnvironmentTarget();
  const bearer = target?.bearerToken;
  if (!target || !bearer || !shouldAttachPrimaryBearer(target)) return base;
  return {
    ...base,
    credentials: "omit",
    headers: {
      ...(base.headers as Record<string, string> | undefined),
      Authorization: `Bearer ${bearer}`,
    },
  };
}

function shouldAttachPrimaryBearer(target: PrimaryEnvironmentTarget): boolean {
  if (target.source !== "desktop-managed") {
    return true;
  }
  if (typeof window === "undefined") {
    return true;
  }

  try {
    const requestBase = new URL(resolveHttpRequestBaseUrl(target.target.httpBaseUrl));
    return requestBase.origin !== window.location.origin;
  } catch {
    return true;
  }
}
